import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Polygon } from '../../polygon/polygon';

interface Data {
  msg?: string;
}

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.ts.html',
  styleUrls: ['./error-dialog.ts.scss'],
  standalone: false,
})
export class ErrorDialog implements OnInit {
  msg?: string;

  constructor(
    public dialogRef: MatDialogRef<Polygon>,
    @Inject(MAT_DIALOG_DATA) public data: Data,
  ) {}

  ngOnInit() {
    this.msg = this.data?.msg;
  }
  onClose(): void {
    this.dialogRef.close();
  }
}
